export const checkDataFreshness = (lastUpdate) => {
  const now = new Date();
  const updateDate = new Date(lastUpdate);
  const diffTime = Math.abs(now - updateDate);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  return {
    isFresh: diffDays <= 2,
    daysSinceUpdate: diffDays
  };
};

export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatDuration = (date) => {
  const currentDate = new Date();
  const targetDate = new Date(date);
  const diffTime = Math.abs(currentDate - targetDate);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  if (diffDays > 30) {
    const months = Math.floor(diffDays / 30);
    return `${months} ${months === 1 ? 'month' : 'months'}`;
  }
  return `${diffDays} ${diffDays === 1 ? 'day' : 'days'}`;
};
